<template>
  <div class="app-container">
    <div class="main_box clearfix">
      <!-- 结转损益 -->
      <div class="item_main clearfix" :style="{height: contentStyleObj}" v-loading="jzsyLoading">
        <div class="top_img clearfix" v-if="showBox">
          <img class="" src="@/assets/carryOver.png">
          <div class="top_button">
            <qzf-button jz="false" button_code="jz_jzsy" v-if="!tableData6[0].status" type="primary" size="mini" @click="gotoCarryForward()" plain>结转损益</qzf-button>
            <qzf-button jz="false" button_code="jz_cxjzsy" v-if="tableData6[0].status" type="primary" size="mini" @click="gotoCarryForward()" plain>重新结转损益</qzf-button>
          </div>
        </div>
        <div class="top_img2 clearfix" v-else-if="!showBox">
            <img class="" src="@/assets/carryOver.png">
           <div class="top_button2">
            <qzf-button jz="false" button_code="jz_jzsy" v-if="!tableData6[0].status" type="primary" size="mini" @click="gotoCarryForward()" plain>结转损益</qzf-button>
            <qzf-button jz="false" button_code="jz_cxjzsy" v-if="tableData6[0].status" type="primary" size="mini" @click="gotoCarryForward()" plain>重新结转损益</qzf-button>
          </div>
        </div>
        <div class="item_box" v-for="item in lossList" :key="item">
          <div class="item" v-if="item.match('错误')">
            <i class="el-icon-error"></i>
            <p>{{item}}</p>
          </div>
          <div class="item" v-else-if="item.match('提示')">
            <i class="el-icon-warning"></i>
            <p>{{item}}</p>
          </div>
          <div class="item" v-else-if="item.match('正常')">
            <i class="el-icon-success"></i>
            <p>{{item}}</p>
          </div>
        </div>
      </div>
      <!-- 结账 -->
      <div class="item_main" :style="{height: contentStyleObj}" v-loading="jzLoading">
        <div class="top_img clearfix" v-if="showBox2">
          <img class="" src="@/assets/carryOver2.png">
          <div class="top_button">
            <qzf-button button_code="jz_fjz" jz="false" v-if="settleStatus != ''" type="danger" size="mini" @click="settlefan()" plain>反结账</qzf-button>
            <qzf-button button_code="jz_jz" jz="false" v-else type="danger" size="mini" @click="goCarryOver()" plain>结账</qzf-button>
          </div>
        </div>
        <div class="top_img2 clearfix" v-else-if="!showBox2">
          <img class="" src="@/assets/carryOver2.png">
          <div class="top_button2">
            <qzf-button button_code="jz_fjz" jz="false" v-if="settleStatus != ''" type="danger" size="mini" @click="settlefan()" plain>反结账</qzf-button>
            <qzf-button button_code="jz_jz" jz="false" v-else type="danger" size="mini" @click="goCarryOver()" plain>结账</qzf-button>
          </div>
        </div>
        <div class="item_box" v-for="item in list" :key="item">
          <div class="item" v-if="item.match('错误')">
            <i class="el-icon-error"></i>
            <p>{{item}}</p>
          </div>
          <div class="item" v-else-if="item.match('提示')">
            <i class="el-icon-warning"></i>
            <p>{{item}}</p>
          </div>
          <div class="item" v-else-if="item.match('正常')">
            <i class="el-icon-success"></i>
            <p>{{item}}</p>
          </div>
        </div>
      </div>
      <!-- 风险评测 -->
      <div class="item_main" :style="{height: contentStyleObj}" v-loading="fxcpLoading">
        <h6>*温馨提示：风险评测不影响做账，可不操作！</h6>
        <div class="top_img clearfix" v-if="showBox3">
          <img class="" src="@/assets/carryOver3.png">
          <div class="top_button">
            <qzf-button jz="false" button_code="jz_fxcp" type="success" size="mini" @click="goRisk()" plain>风险评测</qzf-button>
          </div>
        </div>
        <div class="top_img2 clearfix" v-else-if="!showBox3">
          <img class="" src="@/assets/carryOver3.png">
          <div class="top_button2">
            <qzf-button jz="false" button_code="jz_fxcp" type="success" size="mini" @click="goRisk()" plain>风险评测</qzf-button>
          </div>
        </div>
        <div class="item_box" v-for="item in riskList" :key="item">
          <div class="item" v-if="item.match('错误')">
            <i class="el-icon-error"></i>
            <p>{{item}}</p>
          </div>
          <div class="item" v-else-if="item.match('提示')">
            <i class="el-icon-warning"></i>
            <p>{{item}}</p>
          </div>
          <div class="item" v-else-if="item.match('正常')">
            <i class="el-icon-success"></i>
            <p>{{item}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { profitAndLoss, reverseCheckout, checkOut } from '@/api/carryover.js'
export default {
  name: "settleAccount",
  data() {
    return {
      comId:0,
      period:'',
      contentStyleObj:{}, //高度变化
      list:[],
      settleStatus:'',
      category: '',
      tableData6:[
        {
          id: 1,
          name: '结转损益',
          status: false
        }
      ],
      lossList:[],
      riskList:[],
      showBox:true,
      showBox2:true,
      showBox3:true
    };
  },
  created() {
    // 获取表格高度
    this.contentStyleObj=this.$getHeight(160)
    this.init()
  },
  methods: {
    init(){
      this.settleStatus = this.$checkSettleStatus()
    },
    //反结账
    settlefan(){
      this.showBox2 = true
      this.list = []
      this.showBox = true
      this.lossList = []
      this.showBox3 = true
      this.riskList = []
      let param = {
        comId: this.$store.getters['user/comInfo'].comId*1,
        period: this.$store.getters['user/comInfo'].period
      }
      reverseCheckout([param]).then(res=>{
        if(res.data.msg != "success"){
          return
        }
        this.$store.dispatch('commons/InitPeriod', param.comId).then(res=>{
          this.init()
        })
      })
    },
    //结账
    goCarryOver(){
      this.jzLoading = true;
      this.showBox2 = false
      this.showBox = true
      this.lossList = []
      this.showBox3 = true
      this.riskList = []

      let param = {
        comId: this.$store.getters['user/comInfo'].comId*1,
        period: this.$store.getters['user/comInfo'].period
      }
      checkOut([param]).then(res=>{
        this.jzLoading = false;
        if(res.data.msg == "success"){
          if(res.data.data.status){
            this.$message({
              type: 'success',
              message: '结账成功'
            });
          } else{
            this.$message({
              type: 'error',
              message: '结账失败'
            });
          }
          this.$store.dispatch('commons/InitPeriod', param.comId).then(res=>{
            this.init()
          })
          
        }
        if(res.data.data.list){
          this.list = res.data.data.list
        } else{
          this.list = []
        }
      })
    },
    gotoCarryForward() {
      this.jzsyLoading = true;
      this.showBox = false
      this.showBox2 = true
      this.list = []
      this.showBox3 = true
      this.riskList = []
      profitAndLoss({}).then(res => {
        this.jzsyLoading = false;
        if(res.data.msg == "success"){
          if(res.data.data.status){
            this.$message({
              type: 'success',
              message: '结转损益成功'
            });
          } else{
            this.$message({
              type: 'error',
              message: '结转损益失败'
            });
          }
        }
        if(res.data.data.list){
          this.lossList = res.data.data.list
        } else{
          this.lossList = []
        }
        // this.getList()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.main_box{
  width: 100%;
  display: flex;
  flex-direction:row;
  justify-content : flex-start;
}
.top_img{
  width: 300px;
  height: 300px;
  margin: 0 auto;
  margin-bottom: 30px;
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  img{
    width: 100%;
    height: 100%;
  }
}
.top_button{
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.top_img2{
  display: flex;
  flex-direction:row;
  align-items : center;
  margin-bottom: 30px;
  img{
    float: left;
    width: 150px;
    height: 150px;
  }
}
.top_button2{
  float: left;
  margin-left: 20px;
  text-align: left;
}
.item_main{
  width: calc(100% / 3);
  margin-left: 10px;
  padding: 10px;
  position: relative;
  background: #f7f7f7;
  h6{
    font-size: 14px;
    color: #f56c6c;
    line-height: 24px;
    margin-top: 20px;
  }
  // box-shadow: 2px 3px 10px #eee;
  .item_box{
    .el-icon-error{
      color: #f56c6c;
    }
    .el-icon-success{
      color: #67c23a;
    }
    .el-icon-warning{
      color: #e6a23c;
    }
    .item{
      display: flex;
      flex-direction:row;
      justify-content : flex-start;
      border-bottom: 1px dashed #ccc;
      i{
        line-height: 36px;
        font-size: 17px;
      }
      p{
        font-size: 14px;
        color: #666;
        line-height: 36px;
        margin-left: 6px;
      }
    }
  }
  &:first-child{
    margin-left: 0;
  }
}
</style>